const logsTypes = {
    "main": "Główny",
    "case-status": "Status sprawy",
    "registry": "Rejestr",
    "user": "Użytkownik",
    "webservice": "Webservice"
}

export default logsTypes;


// WEBPACK FOOTER //
// ./src/constants/logsTypes.js